// tslint:disable: max-classes-per-file

import { AccountViewModel } from '@models/account.class';

export class TradeTransferSources<T> {
  constructor(
    public id: string,
    public name: string,
    public group: string,
    public data: T,
  ) {}
}

export class TradeTransferModel {
  constructor(
    public origin: TradeTransferSources<AccountViewModel>,
    public amount: number,
    public concept: string = '',
    public reference: string = '',
    public availableBalance = 0,
    public destination?: TradeTransferSources<AccountViewModel>,
  ) {}

  get valid() {
    return !!(
      this.origin &&
      this.destination &&
      this.availableBalance >= this.amount &&
      this.amount > 0
    );
  }

  get invalidAmount() {
    return this.amount > this.availableBalance;
  }
}
